import { StyledRegionCard, StyledRegionList, StyledRegionListWrapper } from 'pages/Dashboard/components/styled'
import styled from 'styled-components'

const branchListTemplates = {
	...StyledRegionList,
	...StyledRegionListWrapper
}

export const StyledBranchListWrapper = styled.div`
	h2{
		font-size: 36px;
		font-weight: 600;
		color: #434343;
		@media (max-width: 1200px){
			font-size: 28px;
		}
		@media (max-width: 768px){
			font-size: 23px;
		}
		@media (max-width: 416px){
			font-size: 22px;
			margin-left: -4px;
		}
		@media (max-width: 330px){
			font-size: 18px;
		}
	}
	& .branchListAndTitle {
		color: #8DDBCD;
		font-size: 18px;
		font-weight: 600;
		position: relative;
		& .branchListTitle{
			width: fit-content;
			display: flex;
			align-items: center;
			cursor: pointer;
			font-size: 18px;
			& svg {
				transition: transform ease 0.2s;
				transform: ${props => props.listVisible ? 'rotate(180deg)' : 'none'}; 
			}
			@media(max-width: 768px){
				font-size: 14px;
			}
			@media(max-width: 450px){
				font-size: 12px;
			}
			@media(max-width: 416px){
				font-size: 11px;
			}
			@media(max-width: 363px){
				font-size: 2.3vw;
			}
		}
		& .length{
			color: #CDCDCD;
			margin-left: 10px;
		}
		@media (max-width: 576px) {
			font-size: 15px;
		}
		@media (max-width: 400px) {
			font-size: 13px;
		}
		@media (max-width: 350px) {
			font-size: 11px;
		}
	}
`

export const StyledBranchList = styled(branchListTemplates)`
	max-height: 300px;
	overflow-y: scroll;
	@media(max-width: 528px){
		width: 40vw;
	}
`

export const StyledBranchCard = styled(StyledRegionCard)`
	min-height: 35px;
	height: auto;
	& h3{
		font-size: 14px;
		font-weight: 400;
		color: #434343;
	}
	@media(max-width: 528px){
		min-height: auto;
		& h3{
			font-size: 12px;
		}
	}
	@media(max-width: 450px){
		& h3{
			font-size: 10px;
		}
	}
	@media(max-width: 416px){
		& h3{
			font-size: 8px;
		}
	}
	@media(max-width: 363px){
		& h3{
			font-size: 2vw;
		}
	}
`
